import { render, staticRenderFns } from "./DistrictIndex.vue?vue&type=template&id=62db0d87&scoped=true&"
import script from "./DistrictIndex.vue?vue&type=script&lang=js&"
export * from "./DistrictIndex.vue?vue&type=script&lang=js&"
import style0 from "./DistrictIndex.vue?vue&type=style&index=0&id=62db0d87&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62db0d87",
  null
  
)

export default component.exports